import type { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import editingSessions from './editing-sessions.js';
import persistence from './persistence.js';

export default function* root(): SagaIterator {
  yield all([fork(persistence), fork(editingSessions)]);
}
